// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Lvnn","content":"LayoutSettings_content__hmv6E"};